import React, { Component } from "react";
import Tooltip from './BinTooltip';
import { withStyles } from "@mui/styles";
import styles from "./box-layout.styles";
import BOX_TYPE from "../enum/box_type";
import "./index.css";
import { withTranslation } from "react-i18next";
import LockIcon from "@mui/icons-material/Lock";
import {
  getColumnIdFromBinId as resolveColumnIdFromBinId,
  isRestrictedByColumnMapping as isColumnRestrictedByMapping,
  shouldShowRestrictionLock,
} from "./columnRestriction";

let nums1 = Array.from(Array(12).keys());
let nums3 = Array.from(Array(3).keys());
let BinIds = [];
let deactivatedBin = [];
let IsSaved;

export class C30Layout extends Component {

  handleChangeIndex = (index) => {
    this.setState({
      selectedUnit: index,
    });
    this.props.getSelectedUnitName(index);
  };

  componentWillReceiveProps() {
    const { deactivatedBins } = this.props;
    if (deactivatedBins && deactivatedBins.length > 0) {
      deactivatedBins.map((item) => {
        if (item) {
          deactivatedBin.push(item);
          let node = document.getElementById(item);
          if (node !== null && node !== undefined) {
            let x = node.parentNode.classList && node.parentNode.classList[2];
            node.parentNode.classList.remove(x);
            let items = document.getElementById(item);
            if (items && items.style) {
              items.style.background =
                "#f87171";
              items.style.color = "#fff";
              items.style.cursor = "pointer";
            }
          }
        }
        return true;
      });
    } else {
      deactivatedBin.map((item) => {
        if (item) {
          var items = document.getElementById(item);
          if (items && items.style) {
            items.style.background =
              "#f8fafc";
            items.style.color = "#000";
            items.style.cursor = "pointer";
            items.style.pointerEvents = "all";
          }
        }
        return true;
      });
      deactivatedBin = [];
    }
  }

  checkIsSaved = (binId) => {
    if (this.props && this.props.BinStatus.length > 0) {
      this.props.BinStatus.map((binitem) => {
        if (binitem.bin_id === binId) {
          IsSaved = true;
        } else {
          IsSaved = false;
        }
        return true;
      });
    } else {
      IsSaved = false;
    }
  };
  openbin = (binId, status, pm_id) => {
    // Check if bin is restricted by column mapping - don't allow opening if restricted
    if (this.isRestrictedByColumnMapping(binId)) {
      console.log('[C30] openbin blocked - bin is restricted by column mapping:', binId);
      return; // Don't allow opening if restricted by column mapping
    }
    
    // Also check combined restriction (group type + column mapping)
    if (this.isRestricted(null, binId)) {
      console.log('[C30] openbin blocked - bin is restricted (combined check):', binId);
      return;
    }
    
    if (status === "Assigned" || status === "Stocked" || status === "Hold") {
      if (this.props.deactivatedBins.includes(binId)) {
        this.props.Selectedbin(binId, this.props.box_position);
        let items = document.getElementById(binId);
        items.style.background =
          "#f87171"; // deavtivated
        items.style.color = "#ffffff";
      }
      this.props.getPrescriptionDetails(binId, pm_id);
    } else {
      // Handle deactivated bins without status - allow activation
      if (this.props.deactivatedBins.includes(binId)) {
        this.props.Selectedbin(binId, this.props.box_position);
        this.props.getPrescriptionDetails(binId, pm_id);
        let items = document.getElementById(binId);
        if (items) {
          items.style.background =
            "#f87171"; // deavtivated
          items.style.color = "#ffffff";
        }
      } else {
        BinIds.map((item) => {
          this.checkIsSaved(item);
          if (item !== binId && IsSaved === false) {
            var items = document.getElementById(item);
            items.style.background =
              "#f8fafc";
          }
          return true;
        });
        BinIds = [];
        BinIds.push(binId);
        if (BinIds.length > 0) {
          this.props.Selectedbin(binId, this.props.box_position);
          var items = document.getElementById(binId);
          items.style.background =
            "#fbbf24";
        }
      }
    }
  };

  getColumns = (
    currentIndex,
    currentColumnCount,
    previousColumnCount,
    side
  ) => {
    let columns = [];
    if (side === "L") {
      for (
        let i = previousColumnCount + currentColumnCount;
        i > previousColumnCount;
        i--
      ) {
        columns.push(
          String.fromCharCode(65 + (i - 1)) + String.fromCharCode(65 + (i - 1))
        );
      }
    } else {
      for (
        let i = previousColumnCount;
        i < previousColumnCount + currentColumnCount;
        i++
      ) {
        columns.push(String.fromCharCode(65 + (i - 1)));
      }
    }
    return columns;
  };

  getCurrentAndPreviousPosition = (side) => {
    const { expansion, ExpansionsCounts, boxTypeId } = this.props;
    let response = {};
    response.currentCount = expansion.bin_column_count;
    if (side === "L") {
      let _expansionsCount =
        ExpansionsCounts && ExpansionsCounts.leftExpansions;
      if (expansion.box_position === -1 || expansion.box_position === "-1") {
        response.previousCount = 0;
      } else {
        response.previousCount = this.excludeCurrentExpansion(
          expansion,
          _expansionsCount
        );
      }
    } else {
      let _expansionsCount = ExpansionsCounts.rightExpansions;
      if (expansion.box_position === 1 || expansion.box_position === "1") {
        if ([BOX_TYPE.Locker, BOX_TYPE.M41].includes(boxTypeId)) {
          response.previousCount = 6;
        } else {
          response.previousCount = 4;
        }
      } else {
        if ([BOX_TYPE.Locker, BOX_TYPE.M41].includes(boxTypeId)) {
          response.previousCount =
            this.excludeCurrentExpansion(expansion, _expansionsCount) + 6;
        } else {
          response.previousCount =
            this.excludeCurrentExpansion(expansion, _expansionsCount) + 4;
        }
      }
    }
    return response;
  };

  excludeCurrentExpansion = (expansion, expansionArray) => {
    let currentUnitIndex = null;
    for (let index = 0; index < expansionArray.length; index++) {
      if (expansionArray[index].expansionId === expansion.id) {
        currentUnitIndex = index;
        break;
      }
    }
    if (currentUnitIndex === null || currentUnitIndex <= 0) {
      return 0;
    }
    return expansionArray
      .slice(0, currentUnitIndex)
      .reduce((sum, item) => sum + Number(item.bin_column_count || 0), 0);
  };

  getColumnIdFromBinId = (binId) => resolveColumnIdFromBinId(binId);

  isRestrictedByColumnMapping = (binId) =>
    isColumnRestrictedByMapping(
      binId,
      this.props.columnMappings,
      this.props.userGroupType
    );

  isRestricted = (groupTypeId, binId) =>
    shouldShowRestrictionLock({
      binId,
      userGroupType: this.props.userGroupType,
      columnMappings: this.props.columnMappings,
      occupiedGroupTypeId: groupTypeId,
    });

  getSideGridStyle = (n, n1, lastRowSpansTwo = false) => {
    const gridColumn = n === 0 ? 1 : 3;
    if (lastRowSpansTwo && n1 === 10) {
      return { gridColumn, gridRow: '11 / span 2' };
    }
    return { gridColumn, gridRow: n1 + 1 };
  };

  getMiddleGridStyle = (n1) => {
    switch (n1) {
      case 0:
        return { gridColumn: 2, gridRow: '1 / span 2' };
      case 2:
        return { gridColumn: 2, gridRow: '3 / span 2' };
      case 4:
        return { gridColumn: 2, gridRow: 5 };
      case 5:
        return { gridColumn: 2, gridRow: 6 };
      case 6:
        return { gridColumn: 2, gridRow: '7 / span 3' };
      case 9:
        return { gridColumn: 2, gridRow: '10 / span 3' };
      default:
        return null;
    }
  };

  getDeactivatedPaperStyle = (extraStyles = {}) => ({
    background:
      "#f87171",
    color: "#fff",
    ...extraStyles,
  });

  renderCell = (
    BinStatus,
    binType,
    binKey,
    pm_id,
    statusClass,
    statusTitle,
    disableClass,
    isdisabledDoor,
    paperStyleOverrides = {},
    gridStyle = {}
  ) => {
    const { classes, isViewPermissionAllowed } = this.props;
    return (
      <div
        key={binKey}
        className={`${classes.c28c30Cell}${isdisabledDoor ? ` ${disableClass}` : ''}`}
        style={{
          ...gridStyle,
          pointerEvents: this.isRestricted(
            BinStatus && BinStatus.group_type_id,
            binKey
          )
            ? "none"
            : isViewPermissionAllowed
            ? "auto"
            : "none",
          cursor: this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)
            ? "not-allowed"
            : isViewPermissionAllowed
            ? "pointer"
            : "not-allowed",
        }}
        onClick={(e) => {
          if (this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)) {
            console.log('[C30] Click blocked - bin is restricted:', binKey);
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          this.openbin(binKey, binType, pm_id);
        }}
      >
        <Tooltip key={binKey} title={statusTitle}>
            <div
              id={binKey}
              className={statusClass}
              style={{ 
                boxShadow: 'none',
                borderRadius: '6px',
                ...paperStyleOverrides,
                ...(this.isRestrictedByColumnMapping(binKey) ? { backgroundColor: '#FFE0B2', border: '2px solid #FF9800', color: '#422006' } : {}),
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id, binKey) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{binKey}
            </div>
        </Tooltip>
      </div>
    );
  };

  renderMiddleColumnCells = (
    n,
    n1,
    elem3,
    BinStatus,
    binType,
    binKey,
    pm_id,
    statusClass,
    statusTitle,
    disableClass,
    isdisabledDoor,
    paperStyleOverrides = {}
  ) => {
    const { classes, isViewPermissionAllowed } = this.props;
    const gridStyle = this.getMiddleGridStyle(n1);
    if (n !== 1 || !gridStyle) {
      return null;
    }
    const displayKey = this.getBinIndexForMiddleColumn(n, n1, elem3);
    return (
      <div
        key={displayKey}
        className={`${classes.c28c30Cell}${isdisabledDoor ? ` ${disableClass}` : ''}`}
        style={{
          ...gridStyle,
          pointerEvents: this.isRestricted(
            BinStatus && BinStatus.group_type_id,
            displayKey
          )
            ? "none"
            : isViewPermissionAllowed
            ? "auto"
            : "none",
          cursor: this.isRestricted(BinStatus && BinStatus.group_type_id, displayKey)
            ? "not-allowed"
            : isViewPermissionAllowed
            ? "pointer"
            : "not-allowed",
        }}
        onClick={(e) => {
          if (this.isRestricted(BinStatus && BinStatus.group_type_id, displayKey)) {
            console.log('[C30] Click blocked - bin is restricted:', displayKey);
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          this.openbin(displayKey, binType, pm_id);
        }}
      >
        <Tooltip key={displayKey} title={statusTitle}>
          <div
            id={displayKey}
            className={statusClass}
            style={{
              boxShadow: 'none',
              borderRadius: '6px',
              ...paperStyleOverrides,
              ...(this.isRestrictedByColumnMapping(displayKey) ? { backgroundColor: '#FFE0B2', border: '2px solid #FF9800', color: '#422006' } : {}),
            }}
          >
            {this.isRestricted(BinStatus && BinStatus.group_type_id, displayKey) && (
              <LockIcon fontSize="12px" />
            )}
            &nbsp;{displayKey}
          </div>
        </Tooltip>
      </div>
    );
  };

  getBinIndexForMiddleColumn = (n, n1, elem3) => {
    let index = null;
    if (n === 1 && n1 === 0) {
      index = elem3[n] + "" + (n1 + 1);
    } else if (n === 1 && n1 === 2) {
      index = elem3[n] + "" + n1;
    } else if (n === 1 && [4, 5].includes(n1)) {
      index = elem3[n] + "" + (n1 - 1);
    } else if (n === 1 && n1 === 6) {
      index = elem3[n] + "" + (n1 - 1);
    } else if (n === 1 && n1 === 9) {
      index = elem3[n] + "" + (n1 - 3);
    } else {
      index =  n === 1 ? (elem3[n] + "" + n1) : (elem3[n] + "" + (n1 + 1));
    }
    return index;
  };

  render() {
    const BoxStatus = {
      ASSIGNED: "8f9c8e02-b9ee-4f29-aeea-670cef022663",
      STOCKED: "4ee90c0f-d4c3-4d53-8014-d7eac4ea2894",
      HOLD: "45593c2c-fc8c-4bf0-854e-e2bf759b7788",
      PICKED_UP: "00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e",
      CANCELLED: "8a994741-402e-4b18-a883-60da7fc94c7b",
      RETURNED: "198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55",
      DEACTIVATED: "4f666da5-bfe0-4fb5-ad77-b92103881220",
    };
    // eslint-disable-next-line
    const {
      classes,
      BinStatus,
      box_position,
      deactivatedBins,
      isViewPermissionAllowed,
      t,
      ADAData,
      PatientID
    } = this.props;
    let elem3 = [];
    let side = box_position < 0 ? "L" : "R";
    if (side === "L") {
      let prevNextCount = this.getCurrentAndPreviousPosition(side);
      let previousExpansionCount =
        prevNextCount && prevNextCount.previousCount
          ? prevNextCount.previousCount
          : 0;
      elem3 = this.getColumns(
        box_position,
        prevNextCount && prevNextCount.currentCount,
        previousExpansionCount,
        side
      );
    } else {
      let prevNextCount = this.getCurrentAndPreviousPosition(side);
      let previousExpansionCount =
        prevNextCount && prevNextCount.previousCount
          ? prevNextCount.previousCount
          : 0;
      elem3 = this.getColumns(
        box_position,
        prevNextCount && prevNextCount.currentCount,
        previousExpansionCount,
        side
      );
    }
    return (
      <div key={this.props.prefix}>
        <div
          className={`${classes.unitFrame} ${classes.c28c30Grid}`}
          style={{
            marginBottom: "3px",
            pointerEvents: isViewPermissionAllowed ? "auto" : "none",
          }}
        >
            {nums1.map((n1) => {
               let doorInx = n1 + 1;
               const isdisabledDoor = Array.isArray(ADAData) && ADAData.some(function (item) {
                   return (
                       item &&
                       item.patient_id === PatientID &&
                       item.ada_compitible === true &&
                       ![7, 8, 9].includes(doorInx)
                   );
               });
               const disableClass = classes.disabledDoor;
              return nums3.map((n) => {
                    if (n !== 1) {
                      let binKey = this.getBinIndexForMiddleColumn(n, n1, elem3);
                      const sideGridStyle = this.getSideGridStyle(n, n1);
                      if (
                        BinStatus &&
                        BinStatus.length &&
                        BinStatus.length > 0
                      ) {
                        for (var i = 0; i < BinStatus.length; i++) {
                          let pm_id = BinStatus[i].id;
                          let bin_id = BinStatus[i].bin_id;
                          let type_id = BinStatus[i].type_id;
                          let isLockedBin = BinStatus[i].is_locked
                          if (bin_id === binKey) {
                            if (type_id === BoxStatus.STOCKED) {
                              return this.renderCell(
                                BinStatus[i],
                                "Stocked",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridOrangeback,
                                t("Global.Prescriptions.Status.Stocked"),
                                disableClass,
                                isdisabledDoor,
                                {},
                                sideGridStyle
                              );
                            }
                            if (type_id === BoxStatus.ASSIGNED) {
                              return this.renderCell(
                                BinStatus[i],
                                "Assigned",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridBlueback,
                                t("Global.Prescriptions.Status.Assigned"),
                                disableClass,
                                isdisabledDoor,
                                {},
                                sideGridStyle
                              );
                            }
                            if (type_id === BoxStatus.HOLD) {
                              return this.renderCell(
                                BinStatus[i],
                                "Hold",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridSkyblueback,
                                t("Global.Prescriptions.Status.Hold"),
                                disableClass,
                                isdisabledDoor,
                                {},
                                sideGridStyle
                              );
                            }
                          }
                        }
                        if (
                          deactivatedBins &&
                          deactivatedBins.length &&
                          deactivatedBins.length > 0 &&
                          deactivatedBins.findIndex(
                            (D) => D === binKey
                          ) > -1
                        ) {
                          return this.renderCell(
                            BinStatus[i],
                            "Available",
                            binKey,
                            null,
                            classes.gridback,
                            "DEACTIVATE",
                            disableClass,
                            isdisabledDoor,
                            this.getDeactivatedPaperStyle(),
                            sideGridStyle
                          );
                        }
                        return this.renderCell(
                          BinStatus[i],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available"),
                          disableClass,
                          isdisabledDoor,
                          {},
                          sideGridStyle
                        );
                      } else {
                        return this.renderCell(
                          BinStatus[i],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available"),
                          disableClass,
                          isdisabledDoor,
                          {},
                          sideGridStyle
                        );
                      }
                    } else {
                      let binKey = this.getBinIndexForMiddleColumn(n, n1, elem3);
                      if (
                        BinStatus &&
                        BinStatus.length &&
                        BinStatus.length > 0
                      ) {
                        for (var j = 0; j < BinStatus.length; j++) {
                          let pm_id = BinStatus[j].id;
                          let bin_id = BinStatus[j].bin_id;
                          let type_id = BinStatus[j].type_id;
                          let isLockedBin = BinStatus[j].is_locked;
                          if (bin_id === binKey) {
                            if (type_id === BoxStatus.STOCKED) {
                              return this.renderMiddleColumnCells(
                                n,
                                n1,
                                elem3,
                                BinStatus[j],
                                "Stocked",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridOrangeback,
                                t("Global.Prescriptions.Status.Stocked"),
                                disableClass,
                                isdisabledDoor,
                              );
                            }
                            if (type_id === BoxStatus.ASSIGNED) {
                              return this.renderMiddleColumnCells(
                                n,
                                n1,
                                elem3,
                                BinStatus[j],
                                "Assigned",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridBlueback,
                                t("Global.Prescriptions.Status.Assigned"),
                                disableClass,
                                isdisabledDoor,
                              );
                            }
                            if (type_id === BoxStatus.HOLD) {
                              return this.renderMiddleColumnCells(
                                n,
                                n1,
                                elem3,
                                BinStatus[j],
                                "Hold",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridSkyblueback,
                                t("Global.Prescriptions.Status.Hold"),
                                disableClass,
                                isdisabledDoor,
                              );
                            }
                          }
                        }
                        if (
                          deactivatedBins &&
                          deactivatedBins.length &&
                          deactivatedBins.length > 0 &&
                          deactivatedBins.findIndex(
                            (D) =>
                              D ===
                              this.getBinIndexForMiddleColumn(n, n1, elem3)
                          ) > -1
                        ) {
                          if (n === 1 && n1 === 0) {
                            const deactivatedBinKey = elem3[n] + "" + (n1 + 1);
                            return this.renderMiddleColumnCells(
                              n,
                              n1,
                              elem3,
                              BinStatus[j],
                              "Available",
                              deactivatedBinKey,
                              null,
                              classes.gridback,
                              "DEACTIVATE",
                              disableClass,
                              isdisabledDoor,
                              this.getDeactivatedPaperStyle()
                            );
                          }
                          if (n === 1 && n1 === 2) {
                            const deactivatedBinKey = elem3[n] + "" + n1;
                            return this.renderMiddleColumnCells(
                              n,
                              n1,
                              elem3,
                              BinStatus[j],
                              "Available",
                              deactivatedBinKey,
                              null,
                              classes.gridback,
                              "DEACTIVATE",
                              disableClass,
                              isdisabledDoor,
                              this.getDeactivatedPaperStyle()
                            );
                          }
                          if (n === 1 && [4, 5].includes(n1)) {
                            const deactivatedBinKey = elem3[n] + "" + (n1 - 1);
                            return this.renderMiddleColumnCells(
                              n,
                              n1,
                              elem3,
                              BinStatus[j],
                              "Available",
                              deactivatedBinKey,
                              null,
                              classes.gridback,
                              "DEACTIVATE",
                              disableClass,
                              isdisabledDoor,
                              this.getDeactivatedPaperStyle()
                            );
                          }
                          if (n === 1 && n1 === 6) {
                            const deactivatedBinKey = elem3[n] + "" + (n1 - 1);
                            return this.renderMiddleColumnCells(
                              n,
                              n1,
                              elem3,
                              BinStatus[j],
                              "Available",
                              deactivatedBinKey,
                              null,
                              classes.gridback,
                              "DEACTIVATE",
                              disableClass,
                              isdisabledDoor,
                              this.getDeactivatedPaperStyle()
                            );
                          }
                          if (n === 1 && n1 === 9) {
                            const deactivatedBinKey = elem3[n] + "" + (n1 - 3);
                            return this.renderMiddleColumnCells(
                              n,
                              n1,
                              elem3,
                              BinStatus[j],
                              "Available",
                              deactivatedBinKey,
                              null,
                              classes.gridback,
                              "DEACTIVATE",
                              disableClass,
                              isdisabledDoor,
                              this.getDeactivatedPaperStyle()
                            );
                          } else {
                            const deactivatedBinKey = this.getBinIndexForMiddleColumn(n, n1, elem3);
                            return this.renderMiddleColumnCells(
                              n,
                              n1,
                              elem3,
                              BinStatus[j],
                              "Available",
                              deactivatedBinKey,
                              null,
                              classes.gridback,
                              "DEACTIVATE",
                              disableClass,
                              isdisabledDoor,
                              this.getDeactivatedPaperStyle()
                            );
                          }
                        }
                        return this.renderMiddleColumnCells(
                          n,
                          n1,
                          elem3,
                          BinStatus[j],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available"),
                          disableClass,
                          isdisabledDoor,
                        );
                      } else {
                        return this.renderMiddleColumnCells(
                          n,
                          n1,
                          elem3,
                          BinStatus[i],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available"),
                          disableClass,
                          isdisabledDoor,
                        );
                      }
                    }
                  });
            })}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(C30Layout));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/C30.layout.js